import React from "react";
import {
  FacebookOutlined,
  InstagramOutlined,
  YoutubeOutlined,
  PinterestOutlined,
  MailOutlined,
  PhoneOutlined,
  ReadOutlined
} from "@ant-design/icons";
import "../styles/Footer.css"; 
const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-logo">
            <span className="footer-logo-text" ><ReadOutlined/> JetSkill</span>
          </div>
          <p className="footer-description">"Browse. Learn. Grow. JetSkill is your gateway to future-ready skills."</p>
        </div>
        <div className="footer-section">
          <h4 className="footer-title">DISCOVERY</h4>
          <ul className="footer-list">
            <li>
              <a href="/all-courses">Courses</a>
            </li>
            <li>
              <a href="/all-courses">Categories</a>
            </li>
            <li>
              <a href="/all-courses?priceMin=0&priceMax=500&sort=-purchaseCount">Top Selling</a>
            </li>
          </ul>
        </div>
        <div className="footer-section">
          <h4 className="footer-title">GET HELPS</h4>
          <ul className="footer-list">
            <li>
              <a href="/about">About Us</a>
            </li>
            <li>
              <a href="/contact-us">Contact</a>
            </li>
            <li>
              <a href="/faqs">FAQs</a>
            </li>
          </ul>
        </div>
        <div className="footer-section">
          <h4 className="footer-title">CONTACT US</h4>
          <p className="footer-text">Address: FPT University</p>
          <p className="footer-text">
            <PhoneOutlined /> (024) 7300 5588
          </p>
          <p className="footer-text">
            <MailOutlined /> jetskill@gmail.com
          </p>
          <div className="footer-social-icons">
            <FacebookOutlined />
            <PinterestOutlined />
            <InstagramOutlined />
            <YoutubeOutlined />
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
